
import { supabase } from "@/integrations/supabase/client";
import { validateUUID } from "@/utils/validation";

export const getOrganizationName = async (organizationId: string) => {
  if (!validateUUID(organizationId)) {
    throw new Error('Invalid organization ID format');
  }

  const { data, error } = await supabase
    .from('organizations')
    .select('name')
    .eq('id', organizationId)
    .single();

  if (error) throw error;
  return data;
};
